import { Guid } from "guid-typescript";
import { DetailInfo, IDetailInfo } from "./detail-info.model";
import { IRuleParemeters } from "./common.model";

export interface IDetailGroupInfo {
    title: string;
    description: string;
    pageBreak: boolean;
    pageBreakTitle: string;
    sortOrder: number;
    detailInfos: IDetailInfo[];
}

export class DetailGroupInfo {

    public static readonly KeyInitials = 'detail-group';
    public uuid = `${DetailGroupInfo.KeyInitials}-${Guid.create()}`;

    constructor(
        public readonly title: string,
        public readonly description: string,
        public readonly pageBreak: boolean,
        public readonly pageBreakTitle: string,
        public readonly sortOrder: number,
        public readonly detailInfos: DetailInfo[],
        public readonly ruleParemeters: IRuleParemeters
    ) { }

    public static fromJson(data: IDetailGroupInfo, ruleParemeters: IRuleParemeters = {}) {
        return new this(
            data.title, data.description, data.pageBreak, data.pageBreakTitle, data.sortOrder,
            data.detailInfos.map(item => DetailInfo.fromJson(item, ruleParemeters)), ruleParemeters
        );
    }

    public get hasAnyVisibleField(): boolean {
        if (!this.detailInfos || this.detailInfos.length === 0) return false;
        return this.detailInfos.some(d => !d.isHiddenByCurrentVariant);
    }
}